module.exports = __webpack_public_path__ + "img/vipGive.cdec2159.png";